"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerIframe = void 0;
const constants_1 = require("../constants");
const iframeUtils_1 = require("../utils/iframeUtils");
const index_1 = __importDefault(require("../utils/overlay/index"));
const useStyles_1 = require("../utils/useStyles");
const updateUrl = (url) => {
    const shadowIframeElement = index_1.default.ACTIVE_OVERLAY?.getIframe();
    if (shadowIframeElement) {
        shadowIframeElement.src = url;
    }
};
function triggerIframe(url, options) {
    const responsiveStyles = (0, useStyles_1.useStyles)();
    const id = options?.id ?? constants_1.IFRAMEID;
    const integratorStyles = (0, iframeUtils_1.createIframeStyles)(options?.styles);
    const iframe = document.createElement('iframe');
    Object.assign(iframe.style, { ...integratorStyles, ...responsiveStyles });
    for (const [key, value] of Object.entries({
        scrolling: 'no',
        frameborder: '0',
        allow: 'camera;microphone',
        src: url,
        id,
        title: options.title,
    })) {
        if (key && value) {
            iframe.setAttribute(key, value);
        }
    }
    if (index_1.default.ACTIVE_OVERLAY) {
        index_1.default.ACTIVE_OVERLAY.destroy();
    }
    const overlay = new index_1.default({
        windowOpener: options.fullscreenWindow || window,
        overlayContent: {
            ...options.overlayContent,
            iframe,
        },
        onDestroy: options.onClose,
        onOverlayClick: () => overlay.destroy(),
        previousActiveElement: options.previousActiveElement,
    });
    overlay.create();
    return {
        iframe: overlay.getIframe(),
        updateUrl,
    };
}
exports.triggerIframe = triggerIframe;
